import React from 'react'
import Popper from '@material-ui/core/Popper';
import { useState, useEffect } from 'react'
import GetManagementStatus from './MyMapUtils/GetManagementStatus';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
const ManagementStatus = window.SIMPL.ManagementStatus;

function FilterButtonStatus(props) {
    const [checkedList, setCheckedList] = useState(props.targetTypes);
    const [checkedListShow, setCheckedListShow] = useState([]);
    const [statusNos, setStatusNos] = useState([]);

    const anchorRef = React.useRef(null);
    const [openStatusPopup, setOpenStatusPopup] = React.useState(false);
    const handleClick = (event) => {
        if(props.isMobileMode){
            props.updateShowFiltersInfo({ type: "filterKind", value: props.filterKind });
            props.updateShowFiltersInfo({ type: "isFacilityType", value: props.isFacilityType });
            props.updateShowFiltersInfo({ type: "targetTypes", value: props.targetTypes });
            props.updateShowFiltersInfo({ type: "label", value: props.label });
            props.onClick();
        }else{
            setOpenStatusPopup(true);
        }
    };
    function onClearClick() {
        setCheckedList([]);
        setCheckedListShow([]);
    }

    const handleClose = () => {
        props.setCheckedTypes(checkedList);
        setOpenStatusPopup(false);
    };
    useEffect(() => {
        var typeDatas = ManagementStatus[props.masterKind];
        var typeData = typeDatas.map(x=>x.no);
        setStatusNos(typeData);

        var list =  props.targetTypes.map(x=>GetManagementStatus(props.masterKind,x,"name"));
        setCheckedListShow(list);
    }, [props.filterKind]);
   
    function getStyle() {
        return {
            background: props.isDisabled ? "#eee" : null,
            display: props.isShow ? null:"none",
            whiteSpace: "normal"
        };
    }

    return (
        <div className="">

            <div ref={anchorRef} className="" />

            <button
                className={"searchfilter-button" + (props.targetTypes?.length > 0 || props.DateTime_str || props.DateTime_end ? " searchfilter-button-highlight" : "")}
                style={getStyle()}
                onClick={handleClick}
                disabled={props.isDisabled}>

                {props.targetTypes && props.targetTypes.length > 0 ?
                    <span>{checkedListShow.join("、")}</span>
                    :
                    <span>{props.label}</span>
                }
                <div className="searchfilter-down"><i className="bi bi-caret-down-fill"></i></div>
            </button>
            <Popper open={openStatusPopup} anchorEl={anchorRef.current} placement={'bottom-start'} transition style={{ zIndex: 10000 }}>
            <ClickAwayListener onClickAway={handleClose}>
                <div role="dialog" className="hovercard noprint">
                    <div className="hovercard-content">
                        <ul role="group" className="hovercard-items">
                                {statusNos && statusNos.map((statusNo) =>
                                    <li key={statusNo} aria-checked="false" role="checkbox" className="hovercard-item" onClick={() => {
                                        let newList;
                                        if (checkedList.includes(statusNo)) {
                                            newList = checkedList.filter(type => type !== statusNo)
                                        } else {
                                            newList = [...checkedList, statusNo]
                                        }
                                        sortValues(newList);
                                        setCheckedList(newList);

                                        var list =  newList.map(x=>GetManagementStatus(props.masterKind,x,"name"));
                                        setCheckedListShow(list);
                                    }}>
                                        <div className="hovercard-check">
                                            <i className={checkedList.includes(statusNo) ? "bi bi-check-square-fill" : "bi bi-square"}></i>
                                        </div>

                                        <div className="hovercard-text">
                                            <span>{GetManagementStatus(props.masterKind,statusNo,"name")}</span>
                                        </div>
                                    </li>
                                    
                                )}
                            </ul>
                </div>
                <div className="hovercard-buttons">
                    <button className="hovercard-button" onClick={onClearClick}>
                        <span className="hovercard-buttontext">クリア</span>
                    </button>
                    <button className="hovercard-button hovercard-lastbutton" onClick={handleClose}>
                        <span className="hovercard-buttontext hovercard-done">適用</span>
                    </button>
                </div>
            </div>
        </ClickAwayListener>
            </Popper>
        </div>

    );

}

function sortValues(arr) {
    arr.sort((a, b) => {
        if (a > b)
            return 1;
        else
            return -1;
    });
}

export default FilterButtonStatus;
